class ProfileSubMenu {
    constructor()
    {
        this.numOfItems = 0;
        this.totalSpace = 0;
        this.breakWidths = [];

        //window.addEventListener('resize', () => this.updateMenu());
    }

    init()
    {
        this.vlinks = jQuery('#profile-subnav-nav');
        this.hlinks = jQuery('#profile-subnav-dropdown-menu');
        this.btn = jQuery('#profile-subnav-dropdown-toggle');
        this.totalNumberOfLinks = this.vlinks.children().length;

        this.vlinks.children().outerWidth(function (i, w) {
            this.totalSpace += w;
            this.numOfItems += 1;
            this.breakWidths.push(this.totalSpace);
        }.bind(this));

        this.profileSubnavDropdown = document.querySelector('.profile-subnav-dropdown');
        this.profileSubnavDropdownNotify = document.querySelector('#profile-subnav-dropdown-toggle notify');

        this.updateMenu();
    }


    updateMenu()
    {
        if (typeof (this.vlinks) === 'undefined') {
            return;
        }
        this.showOrHideMenuItems();

        if (!this.profileSubnavDropdown || !this.profileSubnavDropdownNotify) {
            return;
        }
        let aTags = this.profileSubnavDropdown.querySelectorAll('a');
        let hasHiddenNotifications = false;
        Array.from(aTags).forEach(function (e) {
            let style = window.getComputedStyle(e);
            if (style.display === 'flex') {
                let notify = e.querySelector('notify.active');
                if (notify) {
                    hasHiddenNotifications = true;
                    return false;
                }
            }
        });
        if (hasHiddenNotifications) {
            this.profileSubnavDropdownNotify.classList.add('active');
        } else {
            this.profileSubnavDropdownNotify.classList.remove('active');
        }
    }

    showOrHideMenuItems()
    {
        // Get instant state
        let availableSpace = this.vlinks.width() - 10;
        let numOfVisibleItems = this.vlinks.children().length;
        let requiredSpace = this.breakWidths[numOfVisibleItems - 1];

        // There is not enough space
        if (requiredSpace > availableSpace) {
            this.vlinks.children().last()
                .prependTo(this.hlinks)
                .removeClass('profile-subnav-navitem')
                .addClass('dropdown-item');
            numOfVisibleItems -= 1;
            this.hideOrShowButton(numOfVisibleItems);
            this.showOrHideMenuItems();
            // There is more than enough space
        } else if (availableSpace > this.breakWidths[numOfVisibleItems] && this.totalNumberOfLinks > numOfVisibleItems) {
            this.hlinks.children().first()
                .appendTo(this.vlinks)
                .removeClass('dropdown-item')
                .addClass('profile-subnav-navitem');
            numOfVisibleItems += 1;
            this.hideOrShowButton(numOfVisibleItems);
            this.showOrHideMenuItems();
        }
    }

    hideOrShowButton(numOfVisibleItems) {
        if (numOfVisibleItems === this.numOfItems) {
            this.btn.addClass('d-none');
        } else {
            this.btn.removeClass('d-none');
        }
    }
}